"use strict";
exports.__esModule = true;
exports.getReactedDoc = void 0;
var constants_1 = require("./constants");
var util_1 = require("./util");
var documentStore_1 = require("./store/documentStore");
/**
 * Get a new document with all of the reactive attrs of a source document computed in a single run.
 * @param doc
 * @param schema
 * @param options
 */
exports.getReactedDoc = function (doc, options) {
    if (options === void 0) { options = {}; }
    var _a = options.idAttrKey, idAttrKey = _a === void 0 ? constants_1.DEFAULT_ID_ATTR_KEY : _a, missingIdGenerator = options.missingIdGenerator, _b = options.documentState, documentState = _b === void 0 ? {} : _b;
    var docWithIds = util_1.addTemporaryIdsToDoc(doc, idAttrKey, missingIdGenerator);
    var store = new documentStore_1.DocumentStore({
        nodeSpecs: doc.type.schema.nodes,
        invalidateNode: function () { },
        idAttrKey: idAttrKey,
        documentState: documentState
    });
    var invalidatedIds = Object.keys(store.run(docWithIds));
    return util_1.mapDoc(docWithIds, function (node) {
        var id = node.attrs && node.attrs[idAttrKey];
        if (invalidatedIds.includes(id)) {
            var copy = store.getReactedCopy(node);
            if (copy) {
                return copy;
            }
        }
        return node;
    });
};
